'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'car-side';
var width = 640;
var height = 512;
var aliases = [128663];
var unicode = 'f5e4';
var svgPathData = 'M122.6 32l5.4 0 256 0 3.8 0 2.4 3L515.8 192 624 192l16 0 0 16 0 176 0 16-16 0-49.3 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80l-130.7 0c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80L16 400 0 400l0-16L0 208l0-16 16 0 42.6 0 62-155 2-5zM384 384c0-53 43-96 96-96s96 43 96 96l48 0 0-176-368 0-16 0L16 208l0 176 48 0c0-53 43-96 96-96s96 43 96 96l128 0zM75.8 192L240 192l0-16 0-96 0-32L133.4 48 75.8 192zM256 192l239.4 0L380.2 48 256 48l0 32 0 96 0 16zM160 464a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm400-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarSide = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;